import { render, staticRenderFns } from "./DemoModal.vue?vue&type=template&id=03603925&"
import script from "./DemoModal.vue?vue&type=script&lang=js&"
export * from "./DemoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports